import { LOGOUT_TIMER } from 'src/enums';

class IdleTimer {
  eventHandler: any;
  onTimeout: any;
  interval: any;
  timeoutTracker: any;
  constructor({
    onTimeout,
    onExpired
  }: {
    onTimeout: () => void;
    onExpired: () => void;
  }) {
    this.onTimeout = onTimeout;
    const expiredTime = parseInt(
      localStorage.getItem('_expiredTime') as string,
      10
    );
    console.log('IdleTimer expiredTime');

    if (expiredTime > 0 && expiredTime < Date.now()) {
      console.log('IdleTimer expired');

      onExpired();
      this.cleanUp();
      return;
    }

    this.eventHandler = this.updateExpiredTime.bind(this);
    this.tracker();
    this.startInterval();
  }

  static onAuth() {
    localStorage.setItem('_expiredTime', `${Date.now() + LOGOUT_TIMER}`);
  }

  startInterval() {
    console.log('IdleTimer startInterval');
    // const num = 1;
    this.updateExpiredTime();
    this.interval = setInterval(() => {
      const expiredTimeString = localStorage.getItem('_expiredTime');
      // console.log(num++ + ' seconds');
      // after cleanUp() the expiredTimeString is null, when its null the user should disconnect
      // console.log('expiredTimeString', expiredTimeString);

      if (!expiredTimeString) {
        this.onTimeout();
        this.cleanUp();
        return;
      }
      const expiredTime = parseInt(
        localStorage.getItem('_expiredTime') as string,
        10
      );

      // console.log('expiredTimeString int', expiredTime);

      if (expiredTime < Date.now()) {
        console.log('TIME OUT!');
        if (this.onTimeout) {
          this.onTimeout();
          this.cleanUp();
        }
      }
    }, 1000);
  }

  updateExpiredTime() {
    if (this.timeoutTracker) {
      clearTimeout(this.timeoutTracker);
    }
    console.log('event occured');

    this.timeoutTracker = setTimeout(function () {
      // console.log('event has happened');
      // console.log(`value to set ${Date.now() + (LOGOUT_TIMER)}`);

      localStorage.setItem('_expiredTime', `${Date.now() + LOGOUT_TIMER}`);
    }, 300);
  }

  tracker() {
    window.addEventListener('mousemove', this.eventHandler);
    window.addEventListener('scroll', this.eventHandler);
    window.addEventListener('keydown', this.eventHandler);
  }

  cleanUp() {
    localStorage.removeItem('_expiredTime');
    clearInterval(this.interval);
    window.removeEventListener('mousemove', this.eventHandler);
    window.removeEventListener('scroll', this.eventHandler);
    window.removeEventListener('keydown', this.eventHandler);
  }
}

export default IdleTimer;
